/**
 * Il cookie marcatore che l'app scrive sul dominio condiviso quando l'utente
 * è dentro (`trovanorma_logged_in=1`, non HttpOnly, cancellato al logout).
 * Non porta dati: dice solo «ha un account». Contratto in `docs/news.md` §5.
 */
export const LOGGED_IN_COOKIE =
  process.env.NEXT_PUBLIC_LOGGED_IN_COOKIE_NAME || 'trovanorma_logged_in';
